export const FB_URL = "https://www.facebook.com/EcentraPhilipppines";

export const DEFAULT_CONTENT = {
  nav: {
    brand: "SAM ORTEGA",
    tag: "LEGACY & LEADERSHIP",
    cta: "Initiate Dialogue",
    links: [
      { label: "The Narrative" },
      { label: "The Ecentra Run" },
      { label: "Pillars" },
      { label: "Wellness" },
      { label: "Transformation" },
    ],
  },
  hero: {
    eyebrow: "Entrepreneur · Leader · Builder · Mentor",
    line1: "At present,",
    line2: "the person I have become",
    line3Pre: "is the summation of",
    line3Accent: "30 years",
    line3Post: "of career.",
    subtext:
      "No corporate emblems to recite, no credentialed laurels to list. Just three decades of forged instinct, disciplined resilience, and an unwavering commitment to human elevation — now channeled into one more defining run: building a winning, highly spirited, high-performing sales organization in the network marketing landscape.",
    ctaPrimary: "Read The Manifesto",
    ctaSecondary: "Explore The Ecentra Run",
    badge: "THE ECENTRA RUN · MALAYSIA · PHILIPPINES · SINGAPORE · THE WORLD",
    portrait: "/api/files/sam-ortega-site/uploads/26e726ab-82ee-41cc-9672-76236e6d7692.mp4",
    stats: [
      { n: "30+", l: "Years in the Leadership Crucible" },
      { n: "2", l: "Hats — Boardroom & Field" },
      { n: "10K+", l: "Lives Trained & Mentored" },
      { n: "1", l: "Another Run — A Remarkable Ecentra Journey" },
    ],
  },
  marquee: [
    "ENTREPRENEUR",
    "LEADER",
    "BUILDER",
    "MENTOR",
    "THE ECENTRA RUN",
    "30 YEARS OF CONVICTION",
    "SUSTAINED EXCELLENCE",
    "HOLISTIC WELLNESS",
    "HUMAN TRANSFORMATION",
  ],
  manifesto: {
    eyebrow: "The Manifesto · In Four Chapters",
    headingPre: "Thirty years distilled into ",
    headingAccent: "one conviction",
    headingPost: ": the best is not behind me — it is the run ahead.",
    chapters: [
      {
        num: "01",
        title: "The Summation",
        quote: "Character isn't written in résumés — it is forged across three decades of standing in the fire.",
        body: "At present, the person I have become is the summation of 30 years of career. Not defined by titles held or institutions attended, but by the discipline of seeing people before processes, and conviction before convenience. Every triumph and every setback served as chisel and hammer, shaping the mentor who stands before you today.",
      },
      {
        num: "02",
        title: "The Hunger",
        quote: "The summit is never the finish line — it is only the next base camp.",
        body: "Thirty years in, the fire has not dimmed — it has only grown sharper. This is the quest for another milestone in business: to lead, to build, and to empower more aspiring individuals to greater heights. Not for applause or comfort, but because the hunger to see others rise has never left.",
      },
      {
        num: "03",
        title: "The Rare Combination",
        quote: "The board without the field is theory. The field without the board is a personality cult.",
        body: "Most people in this industry wear one hat. I have worn both — and the story now names that rare combination. It is the difference between building on paper and building with people.",
        hats: [
          {
            label: "Hat One",
            name: "The Corporate Strategist",
            detail: "President, CEO, VP for Marketing, Director, trusted consultant. Architect of compensation plans, operations frameworks, compliance systems, and corporate rebranding. The boardroom hat — structure, strategy, and the discipline of building companies that endure.",
          },
          {
            label: "Hat Two",
            name: "The Field Leader & Builder",
            detail: "Master Distributor, Field Vice President, Diamond ranks, top earner. Personally led thousands of distributors — and kept producing while leading. The field hat — recruiting, duplication, momentum, and the credibility of never asking anyone to do what I haven't done.",
          },
        ],
        closing: "Both hats come into this run through Ecentra.",
      },
      {
        num: "04",
        title: "Another Run",
        quote: "Another run. Greater stakes. Boundless human potential.",
        body: "And so the story continues — not toward retirement, but toward reinvention. I am making another run, this time to help more people become a better version of themselves. The next chapter will not be about what I built, but about who I helped become.",
      },
    ],
  },
  ecentra: {
    eyebrow: "The Next Chapter · Ecentra",
    image: "/api/files/sam-ortega-site/uploads/05f2ada8-620e-45e7-8719-bed901769553.mp4",
    h1a: "Another Run.",
    h1b: "The quest for breakthrough",
    h1c: "continues through Ecentra.",
    paragraph:
      "Thirty years taught me how networks breathe, how leaders are made, and how trust compounds. Now every lesson converges into a single purpose: to create a legacy of wellness, ownership, and transformation for thousands of families.",
    cta: "Join The Ecentra Movement",
    ctaUrl: FB_URL,
    highlights: [
      { k: "Origin", v: "A network marketing company headquartered in Malaysia" },
      { k: "Frontier", v: "The Philippines, Southeast Asia, and beyond" },
      { k: "Vehicle", v: "Premium wellness paired with an empowering business ecosystem" },
      { k: "Mission", v: "A lasting legacy measured in leaders created, not in titles held" },
    ],
  },
  pillars: {
    eyebrow: "Four Pillars of Impact",
    headingPre: "Entrepreneur. Leader.",
    headingAccent: "Builder. Mentor.",
    sub: "Not titles on a business card — four disciplines practiced daily across thirty years of building people.",
    items: [
      {
        name: "Entrepreneur",
        title: "Architect of Independent Enterprise",
        desc: "Translating vision into sustainable business models that let everyday professionals own their economic destiny.",
      },
      {
        name: "Leader",
        title: "Conviction in Uncertain Climates",
        desc: "Leading from the frontlines with principled clarity, emotional maturity, and disciplined execution.",
      },
      {
        name: "Builder",
        title: "Infrastructure for High Performance",
        desc: "Constructing enduring networks, training academies, and duplication systems that withstand market cycles.",
      },
      {
        name: "Mentor",
        title: "Catalyst of Human Greatness",
        desc: "Guiding leaders beyond self-imposed limits through structured coaching and heart-led accountability.",
      },
    ],
  },
  twin: {
    eyebrow: "Two Roads, One Destination",
    sections: [
      {
        tag: "Vitality & Science",
        title: "Your Wellness Journey",
        subtitle: "Cellular Longevity & Modern Holistic Health",
        desc: "True leadership demands vitality. Through Ecentra's wellness philosophy and holistic lifestyle paradigms, we cultivate the energy, clarity, and resilience required to build something that outlasts us.",
        linkLabel: "Your Wellness Journey Starts Here",
        linkUrl: FB_URL,
        img: "",
      },
      {
        tag: "Sovereignty & Impact",
        title: "Empowerment and Transformation",
        subtitle: "From Individual Aspiration to Collective Mastery",
        desc: "Network Marketing through Cristination Academy is a human development platform. We equip driven men and women with the mindset, mentorship, and acumen to transform their financial reality through network marketing.",
        linkLabel: "Discover The Transformation Blueprint",
        linkUrl: FB_URL,
        img: "",
      },
    ],
  },
  contact: {
    eyebrow: "Direct Connect",
    headingPre: "Initiate a ",
    headingAccent: "direct conversation",
    headingPost: ".",
    subtext:
      "Whether you are exploring the Ecentra business opportunity, beginning your wellness journey, or seeking a seasoned mentor — leave your details and the conversation begins.",
    quote: "The only way to achieve our dreams is to work with people who share the same passion and aspirations.",
    quoteBy: "— SAM ORTEGA",
    submit: "Send Confidential Message",
    interests: [
      "Partner in the Ecentra Business",
      "Wellness & Health Journey",
      "Mentorship & Leadership",
      "General Inquiry",
    ],
  },
  footer: {
    quotePre: "The greatest run is the one where you bring thousands of champions across the finish line ",
    quoteAccent: "with you",
    quotePost: ".",
    quoteBy: "— SAM ORTEGA",
    fbLabel: "Ecentra Philippines on Facebook",
    fbUrl: FB_URL,
    copyright: "© 2026 Sam Ortega. Thirty years of conviction, one lasting legacy — in alliance with Ecentra, Malaysia.",
  },
};

const isObj = (v) => v !== null && typeof v === "object" && !Array.isArray(v);

export function deepMerge(base, over) {
  if (over === undefined || over === null) return base;
  if (Array.isArray(over)) {
    if (
      Array.isArray(base) &&
      base.length === over.length &&
      over.length > 0 &&
      over.every(isObj) &&
      base.every(isObj)
    ) {
      return over.map((o, i) => deepMerge(base[i], o));
    }
    return over;
  }
  if (isObj(base) && isObj(over)) {
    const out = { ...base };
    for (const k of Object.keys(over)) out[k] = deepMerge(base[k], over[k]);
    return out;
  }
  return over;
}
